import { Trans, useTranslation } from 'react-i18next';

import {
  coinsIcon,
  heartIcon,
  phoneIcon,
  simhelpIcon,
  switchIcon,
  thunderIcon,
} from './assets';
import { TilesComponent } from '../../../../components/Tiles/TilesComponent';

const CardContents = () => {
  const { t } = useTranslation();

  return [
    {
      title: t('landing.get_more_section.card_1.title', 'No Quibble Refunds'),
      subtitle: t(
        'landing.get_more_section.card_1.description',
        'Get your money back if you change your mind!',
      ),
      image: (
        <img
          src={coinsIcon}
          width="126"
          height="126"
          alt="coin"
          loading="lazy"
        />
      ),
    },
    {
      title: t(
        'landing.get_more_section.card_2.title',
        'Trusted Local Networks',
      ),
      subtitle: t(
        'landing.get_more_section.card_2.description',
        'Enjoy priority speeds with a local eSIM plan—no more roaming delays.',
      ),
      image: (
        <img
          src={heartIcon}
          width="126"
          height="126"
          alt="heart"
          loading="lazy"
        />
      ),
    },
    {
      title: t('landing.get_more_section.card_3.title', 'Help In A Hurry'),
      subtitle: t(
        'landing.get_more_section.card_3.description',
        'Speak to a real person—online, by phone, or in store!',
      ),
      image: (
        <img
          src={simhelpIcon}
          width="126"
          height="126"
          alt="simhelp"
          loading="lazy"
        />
      ),
    },
    {
      title: t('landing.get_more_section.card_4.title', 'Connect Instantly'),
      subtitle: t(
        'landing.get_more_section.card_4.description',
        'Get connected before you’ve even collected your luggage.',
      ),
      image: (
        <img
          src={thunderIcon}
          width="126"
          height="126"
          alt="thunder"
          loading="lazy"
        />
      ),
    },
    {
      title: t(
        'landing.get_more_section.card_5.title',
        'Free Yourself Of Roaming Charges',
      ),
      subtitle: t(
        'landing.get_more_section.card_5.description',
        'Grab a pay-as-you-go eSIM plan for just 10% of roaming costs!',
      ),
      image: (
        <img
          src={switchIcon}
          width="126"
          height="126"
          alt="switch"
          loading="lazy"
        />
      ),
    },
    {
      title: t('landing.get_more_section.card_6.title', 'Not Just ‘Data Only’'),
      subtitle: t(
        'landing.get_more_section.card_6.description',
        'Calls and texts available (in popular destinations).',
      ),
      image: (
        <img
          src={phoneIcon}
          width="126"
          height="126"
          alt="phone"
          loading="lazy"
        />
      ),
    },
  ];
};

const LandingGetMoreSection = () => {
  const { t } = useTranslation();

  return (
    <TilesComponent
      useCarousel={true}
      title={
        <Trans
          i18nKey="landing.get_more_section.title"
          defaults="We’re Bringing<br>The Big Brands To eSIM"
        />
      }
      subtitle={t(
        'landing.get_more_section.description',
        'Why risk it with generic, own-brand plans? Sim Local connects you to the #1 network provider in more countries than anyone else. The result? A travel eSIM that actually works—or your money back.',
      )}
      tiles={CardContents()}
    />
  );
};

export default LandingGetMoreSection;
